import { useContext } from 'react';

import Card3D from '@/components/game/3d/object/card/Card3D';
import { GameContext } from '@/state/contexts';
import { getNewsTexturePath } from '@/util/card';
import { logg } from '@/util/logg';

const NewsCardBuilder = ({ viewNewsCards }) => {
	const { seasonalNewsCards }: any = useContext(GameContext);

	logg('seasonalNewsCards');
	logg(seasonalNewsCards);

	if (seasonalNewsCards == null || seasonalNewsCards.length === 0) {
		return;
	}

	const newsCardArray: any = [];

	for (let i = 0; i < seasonalNewsCards.length; i++) {
		const texturePath = getNewsTexturePath(seasonalNewsCards[i]);

		newsCardArray.push(
			<group
				key={`news_group__${i}`}
				position={[3.075 * i - 8, 0.6, -10.6]}
			>
				<Card3D
					key={`news__${i}`}
					texturePath={texturePath}
					viewCardModal={viewNewsCards}
					cardArr={seasonalNewsCards}
				/>
			</group>
		);
	}

	return <>{newsCardArray}</>;
};

export default NewsCardBuilder;
